'use strict';

var React = require('react'),
    PureRenderMixin = require('../mixins/PureRenderMixin');

var IframeForm = React.createClass({
  mixins: [PureRenderMixin],

  propTypes: {
    name: React.PropTypes.string.isRequired,
    action: React.PropTypes.string.isRequired
  },

  render: function () {
    var iframeName = this.props.name + '-iframe';

    var frameStyle = {
      visibility: 'hidden',
      position: 'absolute',
      width: 0,
      height: 0
    };

    return (
      <div>
        <form action={this.props.action} method='post' ref='form' className='Form' target={iframeName}>
          <input name='form_name' value={this.props.name} type='hidden' />
          {this.props.children}
        </form>
        <iframe style={frameStyle}
                ref='iframe'
                id={iframeName}
                name={iframeName}
                src='' />
      </div>
    );
  },

  submit: function () {
    this.refs.form.getDOMNode().submit();
  }
});

module.exports = IframeForm;


/** WEBPACK FOOTER **
 ** ./molecules/IframeForm.jsx
 **/